<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >Добавление физ-хим свойства </v-toolbar>
      <ref-prop-card :mode="'editor'" :prop="localProp" @onPropUpdate="doPropUpdate"></ref-prop-card>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Отмена
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark outlined :disabled="saveDisabled" @click="doSave">
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'
import RefPropCard from '@/components/modules/references/cards/refPropCard'

export default {
  name: 'refAddPropDialog',
  components: { RefPropCard },
  props: ['prop', 'value'],
  data () {
    return {
      localProp: null
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localProp ? this.localProp.PROP_ID ? 'Сохранить' : 'Создать' : ''
      }
    },
    hdrText: {
      get () {
        return this.localProp ? this.dataNew ? 'Добавление' : 'Редактирование' : 'Добавление'
      }
    },
    dataNew: {
      get: function () {
        return !this.localProp.PROP_ID
      }
    },
    dataChanged: {
      get () {
        if (!this.prop) return false
        if (this.dataNew) return true
        return this.prop.PROP_CODE !== this.localProp.PROP_CODE || this.prop.PROP_NAME !== this.localProp.PROP_NAME || !this.localProp.EI || this.prop.EI.EI_ID !== this.localProp.EI.EI_ID
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localProp) return true
        const noName = !this.localProp.PROP_NAME
        const noCode = !this.localProp.PROP_CODE
        const noMU = !this.localProp.EI || !this.localProp.EI.EI_ID
        return noName || noCode || noMU || !this.dataChanged
      }
    }
  },
  watch: {
    prop (val) {
      if (val) {
        // eslint-disable-next-line no-undef
        this.localProp = structuredClone(this.prop)
      } else {
        this.localProp = null
      }
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.localProp.PROP_ID ? 'update' : 'add'
      const processorPath = action === 'update' ? '/api/org/references/updProperty.php' : '/api/org/references/addProperty.php'
      const payload = { ...this.localProp }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('propAdded', [resp.data.data])
            } else {
              self.$emit('propUpdate', [resp.data.data])
            }
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doPropUpdate (data) {
      console.log('refAddPropDialog:: doPropUpdate method called ', data)
      this.localProp = { ...this.localProp, ...data }
      console.log('refAddPropDialog:: doPropUpdate current data is ', this.localProp)
    }
  },
  mounted () {
    console.log('refAddPropDialog mounted with property ', this.prop)
  }
}
</script>
